module.exports = "<rc-app-template app-title=\"UP Search\" page-title=\"\" nav-content=app.navContent logout=false> <div class=row> <div class=\"medium-8 large-6 medium-centered column\"> <rc-alerts alerts=app.alerts ng-show=!!app.alerts.length></rc-alerts> </div> </div> <ui-view></ui-view> </rc-app-template>";


//////////////////
// WEBPACK FOOTER
// ./src/app/app.html
// module id = 65
// module chunks = 1